import {useQuery} from '@tanstack/react-query'
import api from 'service/core'

export const useSymposiumScheduleAll = () =>
  useQuery(
    ['symposium-all'],
    () =>
      new Promise((resolve, reject) =>
        api
          .get('pub/symposium-schedule/all')
          .then((response) => resolve(response?.data?.data))
          .catch((error) => reject(error)),
      ),
  )

export const useSymposiumScheduleDetail = (id) =>
  useQuery(
    ['symposium-detail', id],
    () =>
      new Promise((resolve, reject) =>
        api
          .get(`pub/symposium-schedule/${id}/detail`)
          .then((response) => resolve(response?.data?.data))
          .catch((error) => reject(error)),
      ),
    {
      enabled: !!id,
    },
  )
